<div class="logo-container" (click)="redirectHome()" id="top">
    <img alt="HSABank" src="../../../assets/imgs/hsab-logo.png" />
</div>
<button (click)="reset()" class="start-over-button" tabindex=0 *ngIf="displayResetButton">
    <img src="../../../assets/icons/refresh-icon.svg" />
    START OVER
</button>
<button *ngIf="displayOpenCalcButton" class="button filled-green-button open-calc-button" (click)="openCalculator()">Open Calculator</button>